'use-client';
import * as React from 'react';
import type { IResponsivePopupContainerProps } from '../../../ResponsivePopupContainer.types';
import ResponsivePopupContainer from '../../ResponsivePopupContainer';

const WithOverlay = (props: IResponsivePopupContainerProps) => {
  return <ResponsivePopupContainer {...props} withOverlay={true} />;
};

export default WithOverlay;
